import { useState } from "react";
import { Container, Paper, Typography, Box, Avatar, Grid } from "@mui/material"
import { Event } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { Form, Input, Submit } from "../Form";
import { useDispatch, useSelector } from "react-redux";
import { eventIsActive } from "../../features/records/recordSlice";
import FormRecord from "./FormRecord";
import { Confirm } from "../Modal";
import { deleteUser, deleteGuest } from "../../features/records/recordSlice";

const Home = () => {
    const { id } = useSelector(state => state.modal);
    const { isActive } = useSelector(state => state.records);
    const dispatch = useDispatch();
    const [confirm, setConfirm] = useState(true);
    const methods = useForm();

    const changeConfirm = state => setConfirm(state)

    const onSubmit = data => {
        dispatch(eventIsActive({ id: data.clave, setError: methods.setError }));
        methods.reset();
    }
    return(
        isActive ? (
            <>
                <FormRecord changeConfirm={changeConfirm} />
                <Confirm fn={ confirm ? deleteUser({ id }) : deleteGuest({ id })} />
            </>
        ) : (
            <Container component={Paper} maxWidth={'xs'} sx={{ p: '2em' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                    <Avatar sx={{ bgcolor: 'success.main' }}> <Event /> </Avatar>
                    <Typography variant="h5" align="center">Bienvenido al registro de asistencia a eventos!</Typography>
                    <Typography variant="caption">Para poder hacer registros debes escribir la clave del evento.</Typography>
                </Box>  
                <Form methods={methods} onSubmit={onSubmit}>
                    <Grid container spacing={2}>
                        <Input name={'clave'} min={5} max={5} regEx={/\w/ig} label='Clave del evento' />
                        <Submit />
                    </Grid>
                </Form>
            </Container>
        ) 
    )
}

export default Home;